import { AnyAction } from 'redux';
import {
  AuthState,
  GET_RM_DETAIL_SUCCESS,
  GET_USER_INFO_SUCCESS,
  LOGOUT_SUCCESS,
  NEW_VERIFY_LOGIN_OTP_SUCCESS,
  SET_CORRELATION_ID,
  SET_DIY_INVESTOR_ONBOARDING_AUTH_DATA,
  VERIFY_LOGIN_OTP_SUCCESS,
} from '../types/auth';
import { GEN_INV_TOKENCOMPANY_SUCCESS, VERIFY_OTP_PAYMENT_SUCCESS } from '../types/onBoarding';
import { PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS } from '../types/cart';

const initState: Partial<AuthState> = {
  token: null,
  correlationId: null,
  role: null,
  id: null,
};
function authReducer(state = initState, action: AnyAction): Partial<AuthState> {
  switch (action.type) {

    case PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS: {
      return {
        ...state,
        token: action.body.login_token,
        role: action.body.role,
        id: action.body.userId
      }
    }

    case VERIFY_OTP_PAYMENT_SUCCESS: {
      return {
        ...state,
        token: action.body.token,
        role: action.body.role
      }
    }

    case GEN_INV_TOKENCOMPANY_SUCCESS: {
      return {
        ...state,
        ...action.body
      }
    }
    case VERIFY_LOGIN_OTP_SUCCESS:
    case GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        ...action.body,
      };
    }
    case GET_RM_DETAIL_SUCCESS: {
      return {
        ...state,
        userDetails: { ...action.body },
      };
    }
    case SET_CORRELATION_ID: {
      return {
        ...state,
        correlationId: action.correlationId,
      };
    }
    case SET_DIY_INVESTOR_ONBOARDING_AUTH_DATA: {
      return {
        ...state,
        ...action.body,
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initState };
    }
    // case NEW_VERIFY_LOGIN_OTP_SUCCESS: {
    //   return {
    //     ...state,
    //     token: action.body.token,
    //   };
    // }
    default:
      return state;
  }
}

export default authReducer;
